export default "__VITE_ASSET__DkxGmrbj__"